import type { ThresholdPoint } from "@modules/energy-manager/types/alarme"

/** Début de période nuit par défaut (profil uniforme / legacy), en heures. */
export const ALARM_THRESHOLD_DEFAULT_START_NIGHT = 17

/** Fin de période nuit par défaut (matin), en heures. */
export const ALARM_THRESHOLD_DEFAULT_END_NIGHT = 9

/**
 * Indique si un index horaire 0…167 tombe sur le week-end ( bornes legacy
 * `computeProfileHourly`).
 *
 * @param timestamp index horaire 0…167
 * @returns true si tranche week-end
 */
export function getIsLegacyWeekendHour(timestamp: number): boolean {
    return timestamp <= 24 || timestamp >= 144
}

/**
 * Indique si un jour quotidien (0 = dim., 6 = sam.) est un jour de week-end.
 *
 * @param timestamp index jour 0…6
 * @returns true si week-end
 */
export function getIsLegacyWeekendDay(timestamp: number): boolean {
    return timestamp === 0 || timestamp === 6
}

/**
 * Indique si une heure du jour 0…23 est dans la fenêtre « nuit » legacy.
 *
 * @param indexJ heure du jour 0…23
 * @param startNight début (ex. 17h)
 * @param endNight fin matin (ex. 9h)
 * @returns true si cette heure est en nuit
 */
export function getIsLegacyNightHour(
    indexJ: number,
    startNight: number,
    endNight: number
): boolean {
    return (
        (indexJ >= startNight && indexJ <= 24) ||
        (indexJ >= 0 && indexJ <= endNight)
    )
}

/**
 * Valeurs consigne / limites pour un pas horaire selon jour ou nuit.
 *
 * @param index index horaire 0…167
 * @param dayC consigne jour
 * @param dayH limite haute jour
 * @param dayB limite basse jour
 * @param nightEnabled nuit activée
 * @param nightC consigne nuit
 * @param nightH limite haute nuit
 * @param nightB limite basse nuit
 * @param startN début fenêtre nuit
 * @param endN fin fenêtre nuit
 * @returns sous-ensemble ThresholdPoint pour ce pas
 */
export function getHourlyPointValues(
    index: number,
    dayC: number,
    dayH: number,
    dayB: number,
    nightEnabled: boolean,
    nightC: number,
    nightH: number,
    nightB: number,
    startN: number,
    endN: number
): Pick<ThresholdPoint, "consigne" | "limhaute" | "limbasse"> {
    const indexJ = index % 24
    const useNight = nightEnabled && getIsLegacyNightHour(indexJ, startN, endN)
    if (useNight) {
        return {
            consigne: Number(nightC),
            limhaute: Number(nightH),
            limbasse: Number(nightB),
        }
    }
    return {
        consigne: Number(dayC),
        limhaute: Number(dayH),
        limbasse: Number(dayB),
    }
}
